<div class="min-h-screen flex flex-col">
  <!-- PUBLIC HEADER -->
  <div class="fixed top-0 right-0 z-50 p-4">
    <div class="rounded-full bg-white/90 backdrop-blur-md shadow-xl border border-white">
      <app-language-selector [compact]="true" />
    </div>
  </div>

  <!-- CONTENT -->
  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>

  <!-- FOOTER -->
  <app-footer></app-footer>
</div>
